<template>
  <v-data-table :headers="headers"
                :items="contacts"
                :loading="loading"
                :search="search"
                :items-per-page="100"
                :footer-props="{'items-per-page-options': [10, 50, 100, 500, 1000]}">

    <template v-slot:item.fax_number="{item: contact}">
      <router-link :to="{name: `${$root.routePrefix}.send_fax`, query: {contact_id: contact.id}}"
                   title="Send a fax to this contact">
        {{ contact.fax_number_national }}
      </router-link>
    </template>

    <template v-slot:item.id="{item: contact}">
      <div class="text-no-wrap">
        <v-btn v-if="1===2"
               :to="{name: `${$root.routePrefix}.send_fax`, query: {contact_id: contact.id}}"
               small
               icon
               title="Send a fax">
          <v-icon>
            fas fa-fax
          </v-icon>
        </v-btn>

        <v-btn :to="{name: `${$root.routePrefix}.fax_contact.edit`, params: {contactID: contact.id}}"
               x-small
               icon
               title="Edit contact">
          <v-icon>
            fal fa-pencil
          </v-icon>
        </v-btn>
      </div>
    </template>

    <template v-slot:item.created_at="{item: contact}">
      <div class="text-no-wrap">
        {{ contact.created_at | datetime('MMM D, YYYY') }}
      </div>
    </template>
    <template v-slot:item.updated_at="{item: contact}">
      <div class="text-no-wrap">
        {{ contact.updated_at | datetime('MMM D, YYYY') }}
      </div>
    </template>
  </v-data-table>
</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    contacts: {
      type: Array,
      required: true,
    },
    search: {
      type: String,
      required: false,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: 'Company',
          value: 'company_name',
        },
        {
          text: 'Fax Number',
          value: 'fax_number',
          cellClass: 'text-nowrap',
        },
        { // MLD-4007
          text: 'Salutation',
          value: 'salutation',
        },
        {
          text: 'Name',
          value: 'name',
          cellClass: 'text-nowrap',
        },
        {
          text: 'Designation',
          value: 'designation',
        },
        {
          text: 'NPI',
          value: 'npi',
        },
        {
          text: 'City',
          value: 'locality',
        },
        {
          text: 'State',
          value: 'administrative_area',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Created',
          value: 'created_at',
        },
        {
          text: 'Updated',
          value: 'updated_at',
        },
        {
          text: 'Actions',
          value: 'id',
          sortable: false,
        },
      ]
    }
  }
}
</script>
